export default function getResource(label) {
    const resources = {
        free: 'GRATUIT',
        value: 'valeur',
        errorModalTitle: 'Item Out of Stock',
        errorModalText: 'Sorry, this item is out of stock. It will not be added to your basket.',
        errorModalButton: 'Got It'
    };
    return resources[label];
}
